var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylistOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7796 4.02457C25.4051 3.88328 26 4.3588 26 4.99999V7.10247C26 8.73345 24.9035 10.1607 23.3276 10.5809L20 11.4683V18C20 18.0057 20 18.0114 19.9999 18.0172L20 19.3936C20 24.0815 15.4175 26.4933 12.9272 24.0031C10.3506 21.4264 12.8205 17.1992 18.0006 16.9425L18 10.7221C17.9997 10.7069 17.9997 10.6917 18 10.6765L18.0001 8.93085C17.973 7.0087 18.9097 5.64267 20.6838 5.05131C21.325 4.83757 22.6772 4.49952 24.7796 4.02457ZM18 18.9439C14.4621 19.1398 13.1554 21.4028 14.3414 22.5888C15.4843 23.7318 18 22.4077 18 19.3936V18.9439ZM8.5 17C9.05228 17 9.5 17.4477 9.5 18C9.5 18.5523 9.05228 19 8.5 19H4.5C3.94772 19 3.5 18.5523 3.5 18C3.5 17.4477 3.94772 17 4.5 17H8.5ZM13.5 11C14.0523 11 14.5 11.4477 14.5 12C14.5 12.5523 14.0523 13 13.5 13H4.5C3.94772 13 3.5 12.5523 3.5 12C3.5 11.4477 3.94772 11 4.5 11H13.5ZM24 6.25551C22.652 6.57064 21.7511 6.80372 21.3162 6.94867C20.3816 7.26023 19.9849 7.83871 20 8.91676V9.39838L22.8123 8.64844C23.5127 8.46167 24 7.82735 24 7.10247V6.25551ZM15 4.99999C15.5523 4.99999 16 5.44771 16 5.99999C16 6.55227 15.5523 6.99999 15 6.99999H4.5C3.94772 6.99999 3.5 6.55227 3.5 5.99999C3.5 5.44771 3.94772 4.99999 4.5 4.99999H15Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistOutline);
export default __webpack_public_path__ + "static/media/playlist_outline.b0def7547212b9ef5dc176aa3e69ca83.svg";
export { ForwardRef as ReactComponent };